// extracted by mini-css-extract-plugin
module.exports =  {"image":"FNS05Y"};